import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { useActiveOrganization } from '@/hooks/useActiveOrganization';
import { queryKeys } from '@/lib/query-keys';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';
import type {
  GetLearningProgressStatsInput,
  GetLearningProgressStatsOutput,
} from '@/types/learning-progress.types';

export function useLearningProgressStatsQuery(
  targetUserId?: string,
  targetRole?: string,
  weeks?: number
) {
  const { user } = useAuth();
  const { activeOrganizationId } = useActiveOrganization();

  const effectiveUserId = targetUserId || user?.id;

  return useQuery({
    queryKey: queryKeys.learningProgressStats.forUser(
      targetRole ? '__role__' : effectiveUserId!,
      activeOrganizationId,
      targetRole
    ),
    queryFn: () => {
      const body: GetLearningProgressStatsInput = {};
      if (targetRole) {
        body.target_role = targetRole;
      } else if (targetUserId) {
        body.target_user_id = targetUserId;
      }
      if (weeks) {
        body.weeks = weeks;
      }
      return executeQuery<
        GetLearningProgressStatsInput,
        GetLearningProgressStatsOutput
      >(Action.GET_LEARNING_PROGRESS_STATS, body);
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!targetRole || !!effectiveUserId,
  });
}
